/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerGetQueryResponse, IncidentInvestigationControllerGetPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerGet";

function getIncidentInvestigationControllerGetUrl(id: IncidentInvestigationControllerGetPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/incident-agent/investigations/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id}
 */
export async function incidentInvestigationControllerGet(id: IncidentInvestigationControllerGetPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentInvestigationControllerGetUrl(id).url.toString(), ... requestConfig })  
  return res.data
}